<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Raport rar"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="false"
              />
            </div>
          </template>
      <div class="filtre">
        <el-form @submit.prevent.native="refresh_info()">
          <el-row style="margin: 10px" class="input-group">
            <el-col class="input-element">
              <el-form-item label='Interval' size="small">
                <el-date-picker                            
                  v-model="Filters.Data"
                  type="daterange" size="small"
                  range-separator="-"
                  start-placeholder="Data inceput"
                  end-placeholder="Data sfarsit"
                  :picker-options="datePickerOptions"
                  format="dd/MM/yyyy" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
            <el-col class="btn-filter" :md="24">
              <el-button type="primary" native-type="submit" @click="refresh_info()" size="small">Aplica</el-button>
              <el-button type="danger" native-type="submit" @click="reset()" size="small">Reseteaza</el-button>
              <el-button type="success" native-type="submit" @click="exporta()" size="small">Exporta</el-button>
            </el-col>
          </el-row>
        </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table el-table :data="Results">
      <el-table-column prop="Id" label="#" width="80px"></el-table-column>
      <el-table-column prop="DataAprobare" label="DataAprobare"></el-table-column>
      <el-table-column prop="Numar" label="Numar"></el-table-column>
      <el-table-column prop="NumeCentru" label="Centru productie"></el-table-column>
      <el-table-column prop="NumeMecanic" label="Mecanic"></el-table-column>
      <el-table-column prop="NumeClient" label="Client"></el-table-column>
      <el-table-column prop="ValoareDeviz" label="Valoare"></el-table-column>
     
    </el-table>

    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    />
    <Previewdeviz   ref="preview_deviz" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import Previewdeviz from '@/components/Preview_deviz';
import moment from 'moment';

export default {
  name: "raport_rar_pdf",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    Previewdeviz,
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      Results: [],
      base_url: "",
      Info: {
        // clienti: [],
      },
      Filters: {
        Data: [],
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    async preview(id) {
      this.$refs.preview_deviz.show(id)
    },   

    format_zi(data){                               
      return moment(data).format('YYYY-MM-DD')
    },        
    
    calculeaza_durata(start, stop){             
      return moment(stop).diff(start, 'minutes');                  
    },    
    
    format_ora(data){                               
      return moment(data).format('HH:mm')
    },
    
    async get_info() {
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("receptie/devize/get_raport_rar", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("raport_rar");
    },  
    
    async exporta() {
      let isDev = '';
      if (LocalSettings.IS_DEV) { isDev = '/dev' }
      
      window.open(isDev + "/#/raport_rar_pdf/start/" + this.Filters.Data[0] + '/stop/'+ this.Filters.Data[1], '_blank');
    },
    reset() {
      this.Filters = {
        Data: [],
      };
      this.refresh_info();
    },

  },
  mounted() {
    // if (!this.$has_right("Management")) {
    //   this.$router.push("/no-rights");
    //   return;
    // }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}



.input-element {
  width: 50%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .btn-filter {
    display: flex;
    margin-left: 7.5px;
  }

  
  .btn-filter .el-button {
    height: 35px;
    width: 35%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  

  .el-tooltip__popper {
    width: 90%;
  }

  .el-date-editor--daterange.el-input__inner {
    width: 300px;
  }

  .el-picker-panel__body {
    display: flex;
    flex-direction: column;
  }
}
</style>
